import { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const FALLBACK_ID = process.env.REACT_APP_VAPI_ASSISTANT_ID || '19b50344-b56a-49a8-b7e0-47a06358fb20';

let cachedAssistantId = null;
let fetchPromise = null;

export function useActiveAssistant() {
  const [assistantId, setAssistantId] = useState(cachedAssistantId || FALLBACK_ID);

  useEffect(() => {
    if (cachedAssistantId) {
      setAssistantId(cachedAssistantId);
      return;
    }
    if (!fetchPromise) {
      fetchPromise = axios.get(`${API_URL}/api/settings/voice-assistant`)
        .then(res => {
          cachedAssistantId = res.data?.assistant_id || FALLBACK_ID;
          return cachedAssistantId;
        })
        .catch(() => {
          cachedAssistantId = FALLBACK_ID;
          return FALLBACK_ID;
        });
    }
    fetchPromise.then(id => setAssistantId(id));
  }, []);

  return assistantId;
}
